import { render, staticRenderFns } from "./LicenseNotesWidget.vue?vue&type=template&id=25fbba33&lang=pug"
import script from "./LicenseNotesWidget.vue?vue&type=script&lang=js"
export * from "./LicenseNotesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports